<script setup lang="ts">
import { RaceBadge } from '@/components';
import type { Race } from '@/objects/generated';

const props = defineProps<{ races: Race[] }>();
</script>
<template>
    <template
        v-for="(sr, i) in props.races"
        :key="i"
    >
        <RaceBadge :race="sr" />
    </template>
</template>
